import React, {
	useState,
	useEffect,
	useRef,
	Fragment,
	useContext,
} from "react";
import { Modal } from "react-bootstrap";

import * as fCampos from "../JS/campos";
import * as formato from "../JS/formato";

import icono2 from "../../assets/img/icon1_1.svg";
import apps from "../../assets/img/categoria.svg";
import cerrar from "../../assets/img/cerrar.svg";
import aspa from "../../assets/img/aspacierre.svg";
import closeall from "../../assets/img/closeall.svg";
import openall from "../../assets/img/openall.svg";
import SelectMult from "../SelectMult";
import ConexContext from "../../context/ConexContext";

const ModalFiltro = (props) => {
	// CONEX
	const { peticion, tipo_usuario } = useContext(ConexContext);

	// STATES
	const [distVal, setDistVal] = useState([]); //Contiene los valores del distinc
	const [copyConf, setCopyConf] = useState(null); //copia del conf para jugar con él hasta que se le de a aplicar
	const [search, setSearch] = useState(""); // para la busqueda
	const [copyConfs, setCopyConfs] = useState(null); //copia del confs para jugar con él hasta que se le de a aplicar
	const [filtroSelecionado, setfiltroSelecionado] = useState(null);
	// const [filtroSelecionadoAux, setfiltroSelecionadoAux] = useState(null);
	const [valores, setValores] = useState(null);
	// const [nexo, setNexo] = useState("Y");
	const [gFiltAct, setGFiltAct] = useState(0); //agrupación de filtros activa

	// REF
	const buscador = useRef();
	const inputValor = useRef();

	// VARIABLES
	let archivo = require("../../config/filtros.json");

	// FUNCIONES
	// Para cerrar el modal
	function cierra() {
		setfiltroSelecionado(null);
		setValores(null);
		props.onHide();
	}
	//funcion que devuelve el valor del campo moneda, sin formato
	function valorNum(val) {
		val = val.slice(-1) === "€" ? val.slice(0, -1) : val; //quitamos los posibles símbolos
		val = val.replace(/\./g, ""); //quitamos los posibles separadores de miles
		val = val.replace(/,/g, "."); //ponemos el sep. de decimal que le gusta a javascript
		return val * 1;
	}
	function alFoco() {
		if (inputValor.current.value === "") return;
		let val = valorNum(inputValor.current.value);
		if (!Number.isNaN(val)) inputValor.current.value = val;
		inputValor.current.select();
	}
	function alNoFoco() {
		if (inputValor.current.value === "") return;
		let val;
		if ((valores.tipo === "moneda") | (valores.tipo === "numero")) {
			val = formato.formatNum(
				inputValor.current.value,
				valores.tipo === "moneda" ? "€" : "",
				".",
				valores.tipo === "moneda" ? 2 : 0
			);
			if (Number.isNaN(val))
				setValores({ ...valores, valError: "Formato numérico incorrecto" });
			else setValores({ ...valores, valor: val, valError: "" });
		}
	}
	//funcion para modificar lo seleccionado del select múltiple
	function modValor(valor, titulo) {
		setValores({ ...valores, valor: valor, titulo: titulo });
	}
	// Para capturar los cambios de datos del estado de la busqueda
	const handleChange = (event) => {
		setSearch(event.target.value);
	};
	// Para hacer el filtro de la busqueda por nombre
	function filtroCampos(elem) {
		if (
			copyConf[elem].filtros & //el campo es para mostrar en campos
			copyConf[elem].Titulo.toLowerCase().includes(search.toLowerCase()) // filtro de búsqueda
		) {
			return true;
		}
		return false;
	}
	async function getDist(fechaIni, fechaFin, campo) {
		const pet = await peticion(
			`/distinc_custom?fechaIni=${fechaIni}&fechaFin=${fechaFin}&distinc=${campo}`,
			{ method: "POST" }
		);
		if (pet.estado) return; // error
		const arr = [];
		if (
			campo === "Usuario" ||
			campo === "Departamento" ||
			campo === "Empresa" ||
			campo === "Entidad"
		) {
			for (const elem in pet["res"])
				arr.push({
					valor: pet["res"][elem][campo],
					titulo: pet["res"][elem]["Nombre"],
				});
		} else {
			for (const elem in pet["res"])
				arr.push({
					valor: pet["res"][elem][campo],
					titulo: pet["res"][elem][campo],
				});
		}
		setDistVal(arr);
	}
	//añade una agrupación
	function addAgrupacion() {
		copyConfs.filtros_.filtros_.push({
			nexo: "Y",
			filtros_: [],
		});
		setCopyConfs({ ...copyConfs });
		setGFiltAct(copyConfs.filtros_.filtros_.length - 1);
	}
	//borra un filtro concreto, una agrupación o todos
	function borrarFiltro(gFiltro = null, filtro = null) {
		if (gFiltro !== null) {
			if (filtro !== null) {
				if (gFiltro !== -1) {
					setfiltroSelecionado(null);
					copyConfs.filtros_.filtros_[gFiltro].filtros_.splice(filtro, 1);
				}
			} else {
				// borrar agrupacion
				copyConfs.filtros_.filtros_.splice(gFiltro, 1);
				if (gFiltAct === gFiltro)
					//he borrado el activo
					setGFiltAct(copyConfs.filtros_.filtros_.length - 1);
				else if (gFiltro < gFiltAct) setGFiltAct(gFiltAct - 1);
			}
		} else {
			//borrar todos (limpiar)
			copyConfs.filtros_.filtros_.splice(0, copyConfs.filtros_.filtros_.length);
			setGFiltAct(0);
		}
		setCopyConfs({ ...copyConfs });
		setfiltroSelecionado(null);
		setValores(null);
	}
	//Se ha pinchado un filtro
	function abrirFiltro(campo, gFiltro, filtro = null, elem) {
		if (!campo) setfiltroSelecionado(null);
		else
			setfiltroSelecionado({
				...elem,
				campo: campo,
				gFiltro: gFiltro,
				filtro: filtro,
			});
		if (filtro !== null) {
			//estamos editando un filtro
			setGFiltAct(gFiltro); // ponemos el grupo preseleccionado
		}
	}
	// Para añadir un filtro
	function meterFilt() {
		let agrup;
		if (copyConfs.filtros_.filtros_.length === 0) {
			//no hay ninguna agrupacion
			// copyConfs.filtros_.nexo = "Y";
			copyConfs.filtros_.filtros_.push({
				nexo: "Y",
				filtros_: [],
			});
			setGFiltAct(0);
			agrup = copyConfs.filtros_.filtros_[0];
		} else agrup = copyConfs.filtros_.filtros_[filtroSelecionado.gFiltro];
		if (filtroSelecionado.filtro !== null) {
			//no es un filtro nuevo
			// agrup.filtros_[filtroSelecionado.filtro].nexo_ = "Y";
			agrup.filtros_[filtroSelecionado.filtro].valor_ =
				valores.tipo === "texto" || valores.tipo === "distinc"
					? valores.valor
					: valorNum(valores.valor).toString();
			agrup.filtros_[filtroSelecionado.filtro].oper_ = valores.oper;
			agrup.filtros_[filtroSelecionado.filtro].titulo_ = valores.nombre;
			agrup.filtros_[filtroSelecionado.filtro].tipo_ = valores.tipo;
			agrup.filtros_[filtroSelecionado.filtro].titulo = valores.titulo;
		} else {
			//es un filtro nuevo
			if (valores.tipo === "moneda") {
				let filtro = {
					// nexo_: "Y",
					valor_: valorNum(valores.valor).toString(),
					oper_: valores.oper,
					titulo_: valores.nombre,
					tipo_: valores.tipo,
					titulo: valores.titulo,
				};
				agrup.filtros_.push(filtro);
			} else {
				let filtro = {
					// nexo_: "Y",
					valor_:
						valores.tipo === "texto" || valores.tipo === "distinc"
							? valores.valor
							: valorNum(valores.valor).toString(),
					oper_: valores.oper,
					titulo_: valores.nombre,
					tipo_: valores.tipo,
					titulo: valores.titulo,
				};
				agrup.filtros_.push(filtro);
			}
		}
		setCopyConfs({ ...copyConfs });
		setfiltroSelecionado(null);
		setValores(null);
	}
	//salta cuando se selecciona un campo nuevo
	useEffect(() => {
		if (copyConfs === null) return;
		if (props.date1 === null) return;
		if (props.date2 === null) return;
		if (filtroSelecionado && filtroSelecionado.tFiltro === "distinc") {
			getDist(
				props.fechaDB(props.date1),
				props.fechaDB(props.date2),
				filtroSelecionado.nombre
			);
		}
		//valores por defecto
		let val = {
			nombre: filtroSelecionado ? filtroSelecionado.nombre : "",
			tipo: filtroSelecionado ? filtroSelecionado.tFiltro : "",
			oper: "=",
			valor: "",
			titulo: "",
			valError: "",
		};
		// if (val.tipo==='fecha')
		// 	val.oper='<='
		// if (val.tipo==='moneda')
		// 	val.valor=formato.formatNum(val.valor,'€','.',2)
		// else if (val.tipo==='numero')
		// 	val.valor=formato.formatNum(val.valor,'','.',2)
		if (val.tipo === "fecha") val.oper = "<=";
		if (filtroSelecionado && filtroSelecionado.filtro !== null) {
			//es un filtro ya hecho
			val.oper =
				copyConfs.filtros_.filtros_[filtroSelecionado.gFiltro].filtros_[
					filtroSelecionado.filtro
				].oper_;
			val.valor =
				copyConfs.filtros_.filtros_[filtroSelecionado.gFiltro].filtros_[
					filtroSelecionado.filtro
				].valor_;
			if (val.tipo === "moneda")
				val.valor = formato.formatNum(val.valor, "€", ".", 2);
			else if (val.tipo === "numero")
				val.valor = formato.formatNum(val.valor, "", ".", 0);
		}
		setValores(val);
		// eslint-disable-next-line
	}, [filtroSelecionado, copyConfs]);

	// useEffect(()=>{
	// 	console.log(copyConfs)
	// },[copyConfs])

	// useEffect(()=>{
	// 	console.log(valores)
	// },[valores])

	// useEffect(()=>{
	// 	console.log(filtroSelecionadoAux)
	// 	console.log(filtroSelecionado)
	// },[filtroSelecionadoAux, filtroSelecionado])

	// useEffect(()=>{
	// 	console.log(filtroSelecionado)
	// },[filtroSelecionado])

	// Effec para cada vez que abre y cierra el modal
	useEffect(() => {
		//Se acaba de abrir
		if (props.show) {
			setfiltroSelecionado(null);
			setSearch("");
			setCopyConf(fCampos.copy(props.filtros));
			setCopyConfs(fCampos.copy(props.Confs));
		}
	}, [props.show, props.filtros, props.Confs]);
	if (!props.show | !copyConf | !props.filtros | !copyConfs) return "";
	else
		return (
			<Modal
				show={props.show}
				onHide={props.onHide}
				animation={false}
				centered
				size="lg"
				className="modal_filtros">
				<div id="modalcampos">
					<Modal.Body>
						<div className="contmodal fondoazul modales_campos col-xs-12">
							<div className="col-xs-12 nopadding">
								<div className="col-xs-6 nopadding">
									<div className="titular_modal mt-n1 nopadding">
										<img src={icono2} alt="icono" className="icocampos" />
										<h2>Filtros</h2>
									</div>
								</div>
								<div className="col-xs-6 nopadding">
									<div className="contaspacierre">
										<div
											onClick={() => {
												cierra();
											}}
											className="aspacierre">
											<img src={cerrar} alt="cerrar" className="icocerrar" />
										</div>
									</div>
								</div>
							</div>

							<div className="cont_fondocampos col-xs-12 nopadding">
								<div className="fondocampos col-xs-12">
									{/* <ul>
										{
										copyConfs.filtros_ &&
										Object.keys(copyConfs.filtros_).map(
										(elem, i) => (    
											<Fragment key={elem+i}>
											<li
												className="filtro_added"
												key={elem}
											>
												<>
												<div className="ciz"
												style={{cursor:'pointer'}}
												onClick={() => {
													setfiltroSelecionadoAux(elem);
													// setfiltroSelecionado(copyConfs.filtros_[elem]);
													copyConf[Object.keys(copyConf).filter(function(i) { return i === copyConfs.filtros_[elem].titulo_ })].filtro=null;
													setfiltroSelecionado(copyConf[Object.keys(copyConf).filter(function(i) { return i === copyConfs.filtros_[elem].titulo_ })]);
													if (filtroSelecionado.tFiltro==='distinc'){
														getDist(props.fechaDB(props.date1),props.fechaDB(props.date2),filtroSelecionado.nombre)
													}
													let valores_aux={
														nombre:copyConfs.filtros_[elem].titulo_,
														tipo:copyConfs.filtros_[elem].tipo_,
														oper:copyConfs.filtros_[elem].oper_,
														valor:copyConfs.filtros_[elem].valor_,
														valError:''}
													setValores(valores_aux);																
													Object.keys(copyConf).filter(function(i) { return i !== copyConfs.filtros_[elem].titulo_ }).map(
														(elem) =>
															copyConf[elem].filtros &&
															copyConf[elem].seleccionado === true && (
															<>
																{(copyConf[elem].seleccionado = false)}
															</>
															)
														);
													let aux = {...copyConf};	
													aux[Object.keys(copyConf).filter(function(i) { return i === copyConfs.filtros_[elem].titulo_ })].seleccionado=true;
													setCopyConf(aux);

												}}>
													<h5>{copyConfs.filtros_[elem]["titulo_"]} {copyConfs.filtros_[elem]["oper_"]} {(copyConfs.filtros_[elem]["tipo_"]==="moneda" || copyConfs.filtros_[elem]["tipo_"]==="numero") ? (copyConfs.filtros_[elem]["valor_"]):(copyConfs.filtros_[elem]["titulo"])}</h5>
													<small>Filtro por {copyConfs.filtros_[elem]["titulo_"]}</small>
												</div>
												<div className="cde">
													<span>
													<img
														onClick={() => {
																let aux ={...copyConfs};
																aux.filtros_ = aux.filtros_.filter(function(i) { return i !== copyConfs.filtros_[elem] }); // filtramos                               
																setCopyConfs(aux);
																copyConf && Object.keys(copyConf).forEach(id=>{
																	if (copyConf[id].nombre===copyConfs.filtros_[elem]) copyConf[id].seleccionado=false;
																})
																setfiltroSelecionadoAux(null);
																setfiltroSelecionado(null);
														}}
														style={{cursor:'pointer'}}
														src={aspa}
														alt="cerrar filtro"
													/>
													</span>
												</div>
												
												</>
											</li>
												{copyConfs.filtros_.length>1 && i<copyConfs.filtros_.length-1 && 
													<button 
													onClick={()=>{
														// let aux = {...copyConfs};
														// Object.keys(aux.filtros_).map(
														// 	(elem1, i) => ( 
														// 		aux.filtros_[elem1]["nexo_"]==='Y'?aux.filtros_[elem1]["nexo_"]='O':aux.filtros_[elem1]["nexo_"]='Y'
														// 	)										
														// )
														// setNexo(nexo==='Y'?'O':'Y')
														// // aux.filtros_[elem] = { 
														// // 	...aux.filtros_[elem], 
														// // 	nexo_: aux.filtros_[elem].nexo_ === 'Y' ? 'O' : 'Y' 
														// // };
														// setCopyConfs(aux);
														}}
														className="btn_change_oy trash3">
														{copyConfs.filtros_[elem]["nexo_"]}
													</button>
												}
											</Fragment> 
											)
										)}
									</ul> */}
									<ul>
										{copyConfs &&
											copyConfs.filtros_.filtros_.map((elem1, i) => (
												<Fragment key={i}>
													{i !== 0 && (
														<div className="ciz">
															<button
																onClick={() => {
																	let nx = copyConfs.filtros_.nexo === "O" ? "Y" : "O";
																	setCopyConfs({ 
																		...copyConfs, 
																		filtros_: {...copyConfs.filtros_, nexo: nx}
																	});
																}}
																className="btn_change_oy trash3">
																{copyConfs.filtros_.nexo}
															</button>
														</div>
													)}
													<li className="filtro_added" key={i}>
														<div className={"cont_filtro_added_oy"}>
															<div
																onClick={() => {
																	setGFiltAct(i);
																	setfiltroSelecionado(null);
																}}
																className={
																	" insert_filtro clickable" +
																	(gFiltAct === i &&
																	!(
																		filtroSelecionado &&
																		filtroSelecionado.filtro !== null
																	)
																		? " active"
																		: "")
																}>
																<div className="flex-row space-between">
																	<div>{"Agrupación de filtro "+(gFiltAct === i && !(filtroSelecionado && filtroSelecionado.filtro !== null)? "(insertar aquí)":"")}</div>
																	<div className="cde">
																		<span>
																			<img
																				onClick={(e) => {
																					borrarFiltro(i);
																					e.stopPropagation();
																				}}
																				src={aspa}
																				className="aspa"
																				alt="cerrar"
																			/>
																		</span>
																	</div>
																</div>
															</div>
															<div className="flex-row flex-wrap">
																{elem1.filtros_.map((elem2, j) => (
																	<Fragment key={j}>
																		<div
																			style={{
																				cursor: "pointer",
																				fontWeight:
																					filtroSelecionado &&
																					(filtroSelecionado.gFiltro === i) &
																						(filtroSelecionado.filtro === j)
																						? "bold"
																						: "",
																			}}
																			onClick={() => {
																				abrirFiltro(
																					elem2.titulo_,
																					i,
																					j,
																					copyConf[elem2.titulo_]
																				);
																			}}
																			className="info2">
																			<div className="flex-row space-between">
																				<h5>
																					{elem2["titulo_"]} {elem2["oper_"]}{" "}
																					{elem2["tipo_"] === "moneda" ||
																					elem2["tipo_"] === "numero"
																						? elem2["valor_"]
																						: elem2["titulo"]}
																				</h5>
																				<div className="cde">
																					<span>
																						<img
																							alt="borrar"
																							onClick={(e) => {
																								borrarFiltro(i, j);
																								e.stopPropagation();
																							}}
																							src={aspa}
																							className="borrarfiltro"
																						/>
																					</span>
																				</div>
																			</div>
																			<small>Filtro por {elem2["titulo_"]}</small>
																		</div>
																		{elem1.filtros_.length - 1 !== j && (
																			<div className="oy px-3 flex-row align-center">
																				<button
																					onClick={() => {
																						elem1.nexo === "Y"
																							? (elem1.nexo = "O")
																							: (elem1.nexo = "Y");
																						setCopyConfs({ ...copyConfs });
																					}}
																					className="btn_change_oy trash3">
																					{elem1.nexo}
																				</button>
																			</div>
																		)}
																	</Fragment>
																))}
															</div>
														</div>
													</li>
												</Fragment>
											))}
									</ul>
								</div>
								{copyConfs.filtros_ && copyConfs.filtros_.filtros_ && copyConfs.filtros_.filtros_.length > 0 && (
									<div className="col-xs-12 btn_quitartodos conbtn">
										<button
											onClick={() => {
												addAgrupacion();
											}}
											className="btn_quitartodos">
											Nueva agrupación
											<span>
												{" "}
												<img
													src={openall}
													alt="nueva agrupacion"
													className="icocampos"
												/>
											</span>
										</button>
										<button
											onClick={() => {
												borrarFiltro();
												// let aux ={...copyConfs};
												// aux.filtros_= [];
												// setCopyConfs(aux);
												// setfiltroSelecionado(null);
												// setfiltroSelecionadoAux(null);
											}}
											className="btn_quitartodos">
											Quitar todos
											<span>
												{" "}
												<img
													src={closeall}
													alt="quitar todos"
													className="icocampos"
												/>
											</span>
										</button>
									</div>
								)}
							</div>

							<div className="col-xs-12 nopadding">
								<hr />
							</div>

							<div className="col-xs-12 nopadding">
								<div className="categorias col-xs-12">
									<div className="cabecera nopadding col-xs-9">
										<div className="nopadding">
											<input
												ref={buscador}
												type="search"
												id="site-search"
												name=""
												placeholder="Buscar"
												className="mr-2"
												onChange={handleChange}
												defaultValue={search}
											/>
											en{" "}
											<strong>
												{copyConf ? (
													Object.keys(copyConf).filter(filtroCampos).length
												) : (
													<p>0</p>
												)}
											</strong>{" "}
											filtros
										</div>
										<div className="cont_fondocampos_bd">
											<div className="fondocampos">
												<ul>
													{copyConf &&
														Object.keys(copyConf)
															.filter(filtroCampos)
															.filter((elem) => {
																return archivo[copyConf[elem].nombre].Titulo ===
																	"Entidad"
																	? tipo_usuario === "5"
																	: true;
															})
															.map(
																(elem) =>
																	copyConf[elem].filtros &&
																	copyConf[elem].tipo === "filtros" && (
																		<li
																			className={
																				"filtro_added" +
																				(filtroSelecionado &&
																				filtroSelecionado.campo === elem
																					? " activado"
																					: "")
																			}
																			onClick={() => {
																				// if (copyConf[elem].seleccionado) {
																				// 	copyConf[elem].seleccionado = false;
																				// 	setfiltroSelecionado(null);
																				// 	let aux ={...copyConfs};
																				// 	aux.filtros = aux.filtros.filter(function(i) { return i !== copyConf[elem].nombre }); // filtramos
																				// 	setCopyConfs(aux);
																				//   } else {
																				// 	copyConf &&
																				// 	Object.keys(copyConf).map(
																				// 	(elem) =>
																				// 		copyConf[elem].filtros &&
																				// 		copyConf[elem].seleccionado === true && (
																				// 		<>
																				// 			{(copyConf[elem].seleccionado = false)}
																				// 		</>
																				// 		)
																				// 	);
																				// 	let aux1 ={...copyConfs};
																				// 	aux1.filtros= [];
																				// 	setCopyConfs(aux1);

																				// 	copyConf[elem].seleccionado = true;
																				// 	setfiltroSelecionado(copyConf[elem]);
																				// 	let aux ={...copyConfs};
																				// 	aux.filtros.push(copyConf[elem].nombre);
																				// 	setCopyConfs(aux);
																				// }
																				if (
																					filtroSelecionado &&
																					(elem === filtroSelecionado.campo) &
																						(filtroSelecionado.filtro === null)
																				) {
																					abrirFiltro(null);
																				} else {
																					abrirFiltro(
																						elem,
																						gFiltAct,
																						null,
																						copyConf[elem]
																					);
																				}
																			}}
																			key={elem}
																			style={{ cursor: "pointer" }}>
																			<>
																				<div className="ciz">
																					<h5>
																						{
																							archivo[copyConf[elem].nombre]
																								.Titulo
																						}
																					</h5>
																					<small>
																						{
																							archivo[copyConf[elem].nombre]
																								.Descripcion
																						}
																					</small>
																				</div>
																			</>
																		</li>
																	)
															)}
												</ul>
											</div>
										</div>
									</div>
									<div className="cabecera nopadding col-xs-3">
										<h4>
											{filtroSelecionado === "" ||
											filtroSelecionado === "nofiltro"
												? "Nuevo filtro para:"
												: "Editar filtro de: "}
											{filtroSelecionado && filtroSelecionado.Titulo}
											<img src={apps} alt="apps" />
										</h4>
										<div className="categorias">
											<div className="cont_fondooperador_bd ">
												<div className="addoperator_added_yo">
													{(() => {
														switch (
															filtroSelecionado &&
															filtroSelecionado.tFiltro
														) {
															case "texto":
																return (
																	<>
																		<button
																			onClick={() => {
																				setValores({ ...valores, oper: "=" });
																			}}
																			className={
																				"addoperator" +
																				(valores.oper === "=" ? " active" : "")
																			}>
																			<h5>Tiene</h5>
																		</button>
																		<button
																			onClick={() => {
																				setValores({ ...valores, oper: "!=" });
																			}}
																			className={
																				"addoperator" +
																				(valores.oper === "!=" ? " active" : "")
																			}>
																			<h5>No tiene</h5>
																		</button>
																	</>
																);
															case "distinc":
																return (
																	<>
																		<button
																			onClick={() => {
																				setValores({ ...valores, oper: "=" });
																			}}
																			className={
																				"addoperator" +
																				(valores.oper === "=" ? " active" : "")
																			}>
																			<h5>Es</h5>
																		</button>
																		<button
																			onClick={() => {
																				setValores({ ...valores, oper: "<>" });
																			}}
																			className={
																				"addoperator" +
																				(valores.oper === "<>" ? " active" : "")
																			}>
																			<h5>No es</h5>
																		</button>
																	</>
																);
															case "moneda":
																return (
																	<>
																		<div className="p-0 pr-1">
																			<button
																				onClick={() => {
																					setValores({ ...valores, oper: "=" });
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === "="
																						? " active"
																						: "")
																				}>
																				<h5>{"="}</h5>
																			</button>
																		</div>
																		<div className="p-0 pr-1">
																			<button
																				onClick={() => {
																					setValores({
																						...valores,
																						oper: "<=",
																					});
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === "<="
																						? " active"
																						: "")
																				}>
																				<h5>{"<="}</h5>
																			</button>
																		</div>
																		<div className="p-0 pl-1">
																			<button
																				onClick={() => {
																					setValores({
																						...valores,
																						oper: ">=",
																					});
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === ">="
																						? " active"
																						: "")
																				}>
																				<h5>{">="}</h5>
																			</button>
																		</div>
																		<div className="p-0 pr-1">
																			<button
																				onClick={() => {
																					setValores({ ...valores, oper: "<" });
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === "<"
																						? " active"
																						: "")
																				}>
																				<h5>{"<"}</h5>
																			</button>
																		</div>
																		<div className="p-0 pl-1">
																			<button
																				onClick={() => {
																					setValores({ ...valores, oper: ">" });
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === ">"
																						? " active"
																						: "")
																				}>
																				<h5>{">"}</h5>
																			</button>
																		</div>
																	</>
																);
															case "numero":
																return (
																	<>
																		<div className="p-0 pr-1">
																			<button
																				onClick={() => {
																					setValores({ ...valores, oper: "=" });
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === "="
																						? " active"
																						: "")
																				}>
																				<h5>{"="}</h5>
																			</button>
																		</div>
																		<div className="p-0 pr-1">
																			<button
																				onClick={() => {
																					setValores({
																						...valores,
																						oper: "<=",
																					});
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === "<="
																						? " active"
																						: "")
																				}>
																				<h5>{"<="}</h5>
																			</button>
																		</div>
																		<div className="p-0 pl-1">
																			<button
																				onClick={() => {
																					setValores({
																						...valores,
																						oper: ">=",
																					});
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === ">="
																						? " active"
																						: "")
																				}>
																				<h5>{">="}</h5>
																			</button>
																		</div>
																		<div className="p-0 pr-1">
																			<button
																				onClick={() => {
																					setValores({ ...valores, oper: "<" });
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === "<"
																						? " active"
																						: "")
																				}>
																				<h5>{"<"}</h5>
																			</button>
																		</div>
																		<div className="p-0 pl-1">
																			<button
																				onClick={() => {
																					setValores({ ...valores, oper: ">" });
																				}}
																				className={
																					"addoperator" +
																					(valores.oper === ">"
																						? " active"
																						: "")
																				}>
																				<h5>{">"}</h5>
																			</button>
																		</div>
																	</>
																);
															default:
																return null;
														}
													})()}
												</div>
											</div>
										</div>
										<div className="cont_condicion_bd col-xs-12">
											<div className="addcondicion_added_yo ">
												<div className="col-xs-12">
													{(() => {
														switch (
															filtroSelecionado &&
															filtroSelecionado.tFiltro
														) {
															case "texto":
																return (
																	<input
																		ref={inputValor}
																		type="text"
																		id="condition_input"
																		value={valores.valor}
																		onChange={() => {
																			setValores({
																				...valores,
																				valor: inputValor.current.value,
																			});
																		}}
																		placeholder="..."
																	/>
																);
															case "distinc":
																return (
																	<SelectMult
																		distVal={distVal}
																		valores={valores.valor}
																		alCambiar={modValor}
																		campo={filtroSelecionado.nombre}
																	/>
																);
															case "moneda":
																return (
																	<input
																		ref={inputValor}
																		onFocus={() => {
																			alFoco();
																		}}
																		onBlur={() => {
																			alNoFoco();
																		}}
																		type="text"
																		id="condition_input"
																		value={valores.valor}
																		onChange={(e) => {
																			let valor = e.target.value;
																			//las comas son puntos
																			valor = valor.replace(/,/g, ".");
																			const esNumeroValido = /^[0-9]*[.,]?[0-9]*$/.test(valor);
																			if (esNumeroValido || valor === "") {
																				setValores({
																						...valores,
																						valor: valor,
																						valError: ""
																					});
																			} else {
																				setValores({
																						...valores,
																						valError: "Solo se permiten números"
																				});
																			}
																		}}
																		placeholder=""
																	/>
																);
															case "numero":
																return (
																	<input
																		ref={inputValor}
																		onFocus={() => {
																			alFoco();
																		}}
																		onBlur={() => {
																			alNoFoco();
																		}}
																		type="text"
																		id="condition_input"
																		value={valores.valor}
																		onChange={(e) => {
																			let valor = e.target.value;
																			//las comas son puntos
																			valor = valor.replace(/,/g, ".");
																			const esNumeroValido = /^[0-9]*$/.test(valor);
																			if (esNumeroValido || valor === "") {
																				setValores({
																						...valores,
																						valor: valor,
																						valError: ""
																					});
																			} else {
																				setValores({
																						...valores,
																						valError: "Solo se permiten números enteros"
																				});
																			}
																		}}
																		placeholder=""
																	/>
																);
															default:
																return null;
														}
													})()}
												</div>
												<div className="error col-xs-12">
													<span>
														{valores === null ? "" : valores.valError}
													</span>
												</div>
												<div>
													<button
														className={
															valores?.valor === ""
																? "aplicar nopadding mt-2 desactiva"
																: "aplicar nopadding mt-2"
														}
														style={{ width: "100%" }}
														onClick={() => {
															// MODO ANTIGUO
															// if(filtroSelecionadoAux===null){
															// 	if(filtroSelecionado!==""){
															// 		let aux ={...copyConfs};
															// 		if(valores.tipo === "moneda" ){
															// 			let filtro={nexo_: nexo,valor_:valorNum(valores.valor).toString(), oper_:valores.oper, titulo_:valores.nombre, tipo_:valores.tipo, titulo:valores.titulo }
															// 			// Verificar si el filtro ya existe en aux.filtros_
															// 			const existeFiltro = aux.filtros_.some(f =>
															// 				f.nexo_ === filtro.nexo_ &&
															// 				f.valor_ === filtro.valor_ &&
															// 				f.oper_ === filtro.oper_ &&
															// 				f.titulo_ === filtro.titulo_ &&
															// 				f.tipo_ === filtro.tipo_ &&
															// 				f.titulo === filtro.titulo
															// 			);
															// 			// Si no existe, agregarlo
															// 			if (!existeFiltro) {
															// 				aux.filtros_.push(filtro);
															// 			}
															// 		}else{
															// 			let filtro={nexo_: nexo,valor_: valores.tipo === "texto" || valores.tipo === "distinc" ? valores.valor: valorNum(valores.valor).toString(), oper_:valores.oper, titulo_:valores.nombre, tipo_:valores.tipo, titulo:valores.titulo }
															// 			const existeFiltro = aux.filtros_.some(f =>
															// 				f.nexo_ === filtro.nexo_ &&
															// 				f.valor_ === filtro.valor_ &&
															// 				f.oper_ === filtro.oper_ &&
															// 				f.titulo_ === filtro.titulo_ &&
															// 				f.tipo_ === filtro.tipo_ &&
															// 				f.titulo === filtro.titulo
															// 			);
															// 			// Si no existe, agregarlo
															// 			if (!existeFiltro) {
															// 				aux.filtros_.push(filtro);
															// 			}
															// 		}
															// 		setCopyConfs(aux);
															// 		copyConf &&
															// 		Object.keys(copyConf).map(
															// 		(elem) =>
															// 			copyConf[elem].filtros &&
															// 			copyConf[elem].seleccionado === true && (
															// 			<>
															// 				{(copyConf[elem].seleccionado = false)}
															// 			</>
															// 			)
															// 		);
															// 		let aux2 ={...copyConfs};
															// 		aux2.filtros= [];
															// 		setCopyConfs(aux2);
															// 		setfiltroSelecionado(null);
															// 	}else{
															// 		setfiltroSelecionado("nofiltro");
															// 	}

															// }else{
															// 	let aux={...copyConfs}
															// 	aux.filtros_[filtroSelecionadoAux].nexo_=nexo;
															// 	aux.filtros_[filtroSelecionadoAux].valor_= valores.tipo === "texto" || valores.tipo === "distinc" ? valores.valor : valorNum(valores.valor).toString();
															// 	aux.filtros_[filtroSelecionadoAux].oper_=valores.oper;
															// 	aux.filtros_[filtroSelecionadoAux].titulo_=valores.nombre;
															// 	aux.filtros_[filtroSelecionadoAux].tipo_=valores.tipo;
															// 	setCopyConfs(aux);
															// 	copyConf &&
															// 		Object.keys(copyConf).map(
															// 		(elem) =>
															// 			copyConf[elem].filtros &&
															// 			copyConf[elem].seleccionado === true && (
															// 			<>
															// 				{(copyConf[elem].seleccionado = false)}
															// 			</>
															// 			)
															// 		);
															// 		let aux2 ={...copyConfs};
															// 		aux2.filtros= [];
															// 		setCopyConfs(aux2);
															// 	setfiltroSelecionado(null);
															// 	setfiltroSelecionadoAux(null);
															// 	// aux.filtros_[filtroSelecionado]
															// }
															meterFilt();
														}}>
														{filtroSelecionado &&
														filtroSelecionado.filtro !== null
															? "Modificar filtro"
															: "Añadir filtro"}
													</button>
													<button
														className="aplicar nopadding mt-2"
														style={{ width: "100%" }}
														onClick={() => {
															setfiltroSelecionado(null);
														}}>
														{filtroSelecionado &&
														filtroSelecionado.filtro === null
															? "Descartar filtro"
															: "Descartar cambios"}
													</button>
													{/* <div className="error col-xs-12">
														<span>
															{ (filtroSelecionado && filtroSelecionado!=="nofiltro")?'':'No ha seleccionado ningún filtro'}
														</span>
													</div> */}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
				</div>

				<div className="col-xs-12 nopadding">
					<hr />
				</div>

				<Modal.Footer>
					<div className="footer__button-container">
						{filtroSelecionado && valores?.valor && (
							<p className="modificacion-pendiente">
								Tienes cambios pendientes
							</p>
						)}
						<button
							className="cancelar"
							onClick={() => {
								cierra();
							}}>
							Cancelar
						</button>
						<button
							className={`aplicar ${filtroSelecionado && valores?.valor ? "desactiva" : ""}`}
							onClick={() => {
								if (filtroSelecionado && valores?.valor ) return;
								let aux={ ...copyConfs }
								aux.filtros_.filtros_=aux.filtros_.filtros_.filter(grupo => grupo.filtros_.length > 0)
								props.setConfs(aux);
								setGFiltAct(aux.filtros_.filtros_.length - 1);
								cierra();
							}}>
							Aplicar
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		);
};

export default ModalFiltro;
